import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { IntroSplash } from "@/components/IntroSplash";

export function PublicLayout() {
  return (
    <div className="flex min-h-dvh flex-col">
      <IntroSplash />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
